import React from 'react';
import { Field, reduxForm } from 'redux-form';

import ModalBox from '../../../shared/modal';
import SelectField from '../../../shared/form-elements/select/field';
import CheckboxField from '../../../shared/form-elements/checkbox';

const Form = props => {
	const submit = data => props.addOfferFromAffiliateFormSubmit(data);
	return (
		<div className='payouts-transaction-form-wrap payouts-form-in-modal'>
			<form
				className='ui-form payouts-form__main clearfix'
				onSubmit={props.handleSubmit(submit)}
			>
				<div className='payouts-form__main-fields'>
					<div className='ui-form__element affiliates'>
						<Field
							name='affiliate_id'
							placeholder={props.intl('Affiliate')}
							component={SelectField}
							searchable={true}
							multi={false}
							options={props.affiliatesLookups}
						/>
					</div>
					<div className='ui-form__element affiliates'>
						<Field
							name='offer_ids'
							placeholder={props.intl('Offer id (leave empty if add all offers)')}
							component={SelectField}
							searchable={true}
							multi={true}
							options={props.offersLookupAddOfferForm}
						/>
					</div>
					<div className='ui-form__element amount'>
						<Field
							name='is_included_payouts'
							placeholder={props.intl('Include payouts')}
							component={CheckboxField}
							multi={false}
						/>
					</div>
				</div>
				<button
					className='ui-btn ui-btn-primary apply'
					type='submit'
				>{props.intl('Apply')}</button>
				<button
					className='ui-btn ui-btn-cancel cancel'
					onClick={e => {
						e.preventDefault();
						props.toggleAddOfferFromAffiliateForm();
					}}
				>{props.intl('Cancel')}</button>
			</form>
		</div>
	);
};

const Main = props =>
	<ModalBox
		title={props.intl('Add offer from other affiliate')}
		body={Form(props)}
		isOpen={props.isAddOfferFromAffiliateFormVisible}
		onClose={props.toggleAddOfferFromAffiliateForm}
		className='form-modal'
	/>;

export default formName =>
	reduxForm({
		form: formName
	})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/add-offer-from-affiliate-form/main.js